export const isValidEmailAddress = emailAddress =>
    /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+.[a-zA-Z]{2,4}$/.test(emailAddress);

export const isValidPinNumber = pinNumber =>
    pinNumber.length === 4 && /^\d*$/.test(pinNumber);

export const testNameRegex = (name) => /^[A-Za-z0-9-_.,/'&();]+[ A-Za-z0-9-_.,/'&();]*$/.test(name);
